import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  NG_VALUE_ACCESSOR,
  ControlValueAccessor,
  FormControl,
  Validators,
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ControlValueAccessorDirective } from '../../../Helpers/Directives/controlValueAccessor.directive';

@Component({
  selector: 'radio-input',
  templateUrl: './input-radio.component.html',
  styleUrls: ['./input-radio.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioInputComponent),
      multi: true,
    },
  ],
})
export class RadioInputComponent extends ControlValueAccessorDirective {
  @Input() controlName!: FormControl;
  @Input() options: { nameEN: string; name: string; id: any }[] = []; // Options for the radio buttons
  @Input() name: string = ''; // Name for the radio input grou
  @Input() isEnglish: boolean = false;
  // Event handler when a radio button is selected
  showInput: boolean = true;

  @Output() onChangeValue = new EventEmitter();

  public changeValue(val: any) {
    this.value = val;
    this.onChangeValue.emit(val);
    this.onChange(this.value);
  }

  //  override writeValue(value: any): void {
  //     if (value !== undefined) {

  //
  //       this.value = value; // Assign the passed value to the component's internal `value`
  //     }
  //   }

  public get Invalid(): boolean {
    return this.controlName.invalid;
  }

  public get Required(): boolean {
    return this.controlName?.hasValidator(Validators.required) ?? false;
  }
  public get ShowError(): boolean {
    if (!this.controlName) return false;
    const { dirty, touched } = this.controlName;
    return this.Invalid ? dirty || touched : false;
  }
}
